'use client';

import React from 'react';
import { useWidgetConfig } from 'src/context/providers/WidgetConfigProvider';
import { useProfile } from 'src/context/providers/ProfileProvider';
import WidgetLoading from 'src/components/Profiles/shared/widgets/shared/WidgetLoading';
import WidgetEmpty from 'src/components/Profiles/shared/widgets/shared/WidgetEmpty';
import { formatCurrency } from 'src/utils/formatCurrency/formatCurrency';
import { useGetPatientVisitValueQuery } from 'src/api/redux';

const PatientVisitValuePreview: React.FC = () => {
  const widgetConfig = useWidgetConfig();
  const widget = widgetConfig?.widget ?? null;
  const { entityDetails } = useProfile();

  const codeSetId = widget?.code_set?.id;
  const entityId = entityDetails?.id;

  const { data, isLoading } = useGetPatientVisitValueQuery(
    { entityId: entityId ?? '', codeSetId: codeSetId ?? 0 },
    { skip: !entityId || !codeSetId }
  );

  if (isLoading) {
    return <WidgetLoading data-testid="patient-visit-value-preview-loading" aria-label="Loading patient visit value" />;
  }

  if (data?.patient_visit_value == null) {
    return <WidgetEmpty data-testid="patient-visit-value-preview-empty" />;
  }

  return (
    <div
      className="flex flex-col gap-1"
      data-testid="patient-visit-value-preview"
    >
      <span className="text-xs text-neutral-400">
        Their current 15min slot value derived from reimbursement data from{' '}
        {widgetConfig?.dateRangeLabel}
      </span>
      <span
        className="text-3xl font-bold text-sky-900 tabular-nums mt-2"
        data-testid="patient-visit-value-preview-amount"
      >
        {formatCurrency(data.patient_visit_value, {
          abbreviated: false,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </span>
    </div>
  );
};

export default PatientVisitValuePreview;
